import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "overlay"]

  toggle() {
    const isOpen = this.sidebarTarget.classList.contains("events-portal-sidebar--open")
    if (isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.sidebarTarget.classList.add("events-portal-sidebar--open")
    this.overlayTarget.classList.add("events-portal-overlay--visible")
    document.body.style.overflow = "hidden"
  }

  close() {
    this.sidebarTarget.classList.remove("events-portal-sidebar--open")
    this.overlayTarget.classList.remove("events-portal-overlay--visible")
    document.body.style.overflow = ""
  }
}
